import { render, staticRenderFns } from "./Diy.vue?vue&type=template&id=86dacd2a&scoped=true&"
import script from "./Diy.vue?vue&type=script&lang=js&"
export * from "./Diy.vue?vue&type=script&lang=js&"
import style0 from "./Diy.vue?vue&type=style&index=0&id=86dacd2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dacd2a",
  null
  
)

export default component.exports